<template>
  <former-box
    :collapsable="section.collapsable"
    :class="classes"
    :title="section.title"
    :title-class="section.titleClass"
    :start-collapsed="section.startCollapsed"
    :subtitle="sectionSubtitle"
    :subtitle-class="section.subtitleClass"
    :section-separator="section.separator"
    @collapsed="collapse"
  >
    <slot
      v-if="section.slots"
      name="header"
    />

    <ul class="former-section-list-items">
      <li
        :is="is(item)"
        v-for="item in section.items"
        :key="item.id"
        :item="item"
        :class="itemClasses(item)"
        :desktop="desktop"
        :editable="editable"
        :copyable="section.copyable"
        class="former-section-list-item"
        @click.native="edit(item)"
        @change="change"
        @search="search"
      />
    </ul>

    <slot
      v-if="section.slots"
      name="footer"
    />
  </former-box>
</template>

<script>
  import FormerBox from '@/components/Former/Box.vue';
  import FormerSectionFile from '@/components/Former/Section/File.vue';
  import FormerSectionItem from '@/components/Former/Section/Item.vue';
  import FormerSectionSeparator from '@/components/Former/Section/Separator.vue';

  export default {
    name: 'FormerSectionList',
    components: {
      FormerBox,
      FormerSectionFile,
      FormerSectionItem,
      FormerSectionSeparator,
    },
    props: {
      desktop: {
        type: Boolean,
        default: true,
      },
      editable: {
        type: Boolean,
        default: true,
      },
      section: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        collapsed: null,
      };
    },
    computed: {
      sectionSubtitle() {
        const {
          collapsed,
          section,
        } = this;

        return !collapsed && !!section.hidleSubtitleOnCollapsed ? '' : section.subtitle;
      },

      classes() {
        const classes = ['former-section-list'];

        if (this.editable) {
          classes.push('former-section-list-editable');
        }

        classes.push(`former-section-list-${this.collapsed ? 'collapsed' : 'uncollapsed'}`);

        if (this.section.class) {
          classes.push(this.section.class);
        }

        if (this.section.items.length === 0) {
          classes.push('former-section-list-empty');
        }

        return classes;
      },
    },
    methods: {
      collapse(bool) {
        this.collapsed = bool;
      },
      is(item) {
        if (item.type === 'file') {
          return 'former-section-file';
        }

        if (item.separator) {
          return 'former-section-separator';
        }

        return 'former-section-item';
      },
      edit({ id, disabled = false }) {
        if (this.editable && !disabled) {
          this.$emit('edit', id);
        }
      },
      change(id, value) {
        this.$emit('change', id, value);
      },
      search(value, paginate) {
        this.$emit('search', value, paginate);
      },

      itemClasses(item) {
        const classes = ['former-section-list-item'];

        if (item.size) {
          classes.push(`former-section-list-item-size-${item.size}`);
        }

        if (item.separator) {
          classes.push('former-section-list-item-separator');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-section-list {
  }

  .former-section-list-empty {
    padding-bottom: 0;
  }

  .former-section-list-collapsed {
    & + & {
      border-top-width: 1px;
    }
  }

  .former-section-list-items {
    list-style: none;
  }

  .former-section-list-editable {
    .former-section-list-item {
      flex: 1;
      margin: $gutter-big 0;
    }

    @media all and (min-width: $breakpoint-desktop) {
      .former-section-list-items {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin: 0 -1.5%;
      }

      .former-section-list-item {
        margin: $gutter 1.5%;
        max-width: 22%;
        min-width: 22%;
      }

      .former-section-list-item-size-2 {
        max-width: 47%;
        min-width: 47%;
      }

      .former-section-list-item-size-3 {
        max-width: 30.3%;
        min-width: 30.3%;
      }

      .former-section-list-item-size-4,
      .former-section-item-button,
      .former-section-list-item-separator {
        max-width: 97%;
        min-width: 97%;
      }
    }
  }
</style>
